import { useCallback, useEffect, useState } from 'react'

const useCounter = (params) => {
  const [remainingTime, setRemainingTime] = useState(
    () => params.initialTimeSeconds,
  )
  const [isComplete, setIsComplete] = useState(false)
  const [isEnabled, setIsEnabled] = useState(!!params.autoplay)

  const { intervalMiliSeconds } = params

  useEffect(() => {
    if (isEnabled) {
      const timeout = setTimeout(() => {
        setRemainingTime(remainingTime - 1)
      }, intervalMiliSeconds || 1000)

      if (remainingTime <= 0) {
        clearTimeout(timeout)
        setIsComplete(true)
      }
      return () => {
        clearTimeout(timeout)
      }
    }
  }, [remainingTime, intervalMiliSeconds, isEnabled])

  const startCounter = useCallback(() => {
    setIsEnabled(true)
  }, [])

  const stopCounter = useCallback(() => {
    setIsEnabled(false)
  }, [])

  const resetCounter = useCallback(() => {
    setIsComplete(false)
    setRemainingTime(params.initialTimeSeconds)
    setIsEnabled(false)
  }, [params.initialTimeSeconds])

  return {
    isComplete,
    remainingTime,
    startCounter,
    stopCounter,
    resetCounter,
    isRunning: isEnabled,
  }
}

export default useCounter
